import {createBrowserHistory} from 'history';

export const history = createBrowserHistory();

export function routerUpdate(location, routerParams, adminOnly) {
    return dispatch => {
        dispatch({
            type: 'ROUTER_UPDATE',
            location,
            routerParams,
            adminOnly,
        });
    };
}

export function push(location) {
    history.push(location);

    return dispatch => {
        dispatch({
            type: 'ROUTER_LOCATION_CHANGE',
            location,
        });
    };
}
